
import dataservice from "../../core/services/dataservice";
import dayjs from "dayjs";
import _ from "lodash";



export const useReceiptsStore = defineStore("receipts", {
  state: () => {
    return {
      receipts: [],
      date: dayjs().add(-7, "hours").format('YYYY-MM-DD'),
      nonce: _.random(1, 100000000),
      
      unSyncHash: {} as any
    };
  },

  actions: {
    async init() {

      this.restore()
      setInterval(() => {
        this.restore()
      }, 1000 * 60 * 3);

    },
    add(receipt, syncToCloud = false) {


      //check if exist in receipts return
      // let exist = _.find(this.receipts, (v) => {
      //   return v.hash == receipt.hash
      // })

      // if (exist) {
      //   return
      // }

      this.receipts.push(receipt)
    },
    async fetch() {


      const res = await dataservice.receipts.getByDate(this.date)
      this.receipts = res.data;
    },
    async updateCustomGuest(receipt:object, guest:number) {
      let payload = {
          key1:receipt.key1,
          key2:receipt.key2,
          value:guest
      }      

      await dataservice.receipts.updateCustomGuest(payload)     
      setTimeout(() => {             
        return "success"
      }, 2000);
    },
    async markLiveReceipt(receipts:any){
        const payload = receipts.map((r:any)=>{
          return {
            key1:r.key1,
            key2:r.key2
          }
        })      

      return dataservice.receipts.markLiveReceipts({receipts:payload})
    },    

    async voidBill(receipt, reason="") {
      let payload = {
        storeId: useFirebase().getStoreId(),
        ...receipt,
        voided: {
          timestamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          reason: reason || 'voided',
          employee: useEmployeePin().getEmployee()
        }
      }      

      await dataservice.receipts.delete(payload)     
      setTimeout(() => {             
        new ThermalPrinterReceipt().voidBill(payload).print();
      }, 5);
    },

    async processUnsycnReceipts() {
      let _unSyncHash = this.unSyncHash
      this.unSyncHash = {}
      let _receipts = this.receipts.filter(v => _unSyncHash[v.hash])
      _receipts.forEach(async (v) => {
        await dataservice.receipts.create(v)
      })
    },
    async restore() {


      //fake delay for 3 seconds
      // await new Promise((resolve) => {
      //   setTimeout(() => {
      //     
      //     resolve(true)
      //   }, 3000);
      // })
      // return true


       
      let receiptsPayloadList = useOffline().getItemsByType('receipt')
      for (let index = 0; index < receiptsPayloadList.length; index++) {
        const { data, type, key } = receiptsPayloadList[index];

        try {
          await dataservice.receipts.post(data)
          useOffline().release(key)
        } catch (error) {

        }
      }


      return true
    }
  }

});
